<template>
    <v-tooltip bottom>
        <template #activator="{ on, attrs }">
            <div
                class="color-picker-wrapper"
                :class="{ disabled }"
                v-bind="attrs"
                v-on="on">
                <app-icon-button
                    :icon="icon"
                    color="grey"
                    :disabled="disabled"
                    small />
                <input
                    type="color"
                    class="color-input"
                    :value="value || defaultColor"
                    :disabled="disabled"
                    @input="onInput">
            </div>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
import AppIconButton from '@/components/AppIconButton.vue'

export default {
    name: 'RichTextAreaColorPicker',
    components: { AppIconButton },
    props: {
        icon: { type: String, required: true },
        tooltip: { type: String, required: true },
        value: { type: String, default: null },
        defaultColor: { type: String, default: '#000000' },
        disabled: { type: Boolean, default: false }
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value)
        }
    }
}
</script>

<style scoped>
.color-picker-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.color-picker-wrapper.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.color-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 2rem;
    height: 2rem;
    opacity: 0;
    cursor: pointer;
}

.color-input:disabled {
    cursor: not-allowed;
}
</style>



